import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

export const SanityStats = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('stats'),
  _key: z.string(),
  headline: z.string().optional().nullable(),
  stats: z.array(
    z.object({
      _key: z.string(),
      value: z.string(),
      caption: z.string(),
      disableAnimation: z.boolean().optional().nullable(),
    }),
  ),
  theme: z
    .enum(['charcoal', 'electric', 'purple', 'whiteCipher'])
    .optional()
    .nullable(),
  animateValue: z.boolean().optional().nullable(),
  statBackground: HexColor.optional().nullable(),
  statTextColor: HexColor.optional().nullable(),
});
export type SanityStats = z.infer<typeof SanityStats>;

export const stats = groq`{
  headline,
  theme,
  animateValue,
  stats[] {
    _key,
    value,
    caption,
    disableAnimation,
  },
  'statBackground': statBackground->color.hex,
  'statTextColor': statTextColor->color.hex
  }`;
